module.exports = __webpack_public_path__ + "static/bsas016-e38105df224d0209ad460e3e74ce63ad.jpg";